import React from 'react'
import Navbar from './Navbar'

function Privacy() {
  return (
    <>
      <div className="main">
        <div className="main-div">
      <div className="container mt-3">
<div className="">
              <Navbar />
            </div>
          <div className='container mt-4'>
            <div className='mt-5'>
              <h2 className='text-center'>Privacy Policy</h2>
              <div mt-4>
                <p>
                  Welcome to shareitforpcappdownload.com. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our quiz website.
                </p>
              </div>
                <h5>1. Information We Collect</h5>
                <p>Our website may collect the following types of information:</p>
              <div>
               <h6> A.  Basic Usage Data:</h6>
               <p>When you use the website, we may collect:</p>
               <ul>
                <li>Device type</li>
                <li>Browser type</li>
                <li>IP address</li>
                <li>Time spent on quizzes</li>
               </ul>
              </div>
              <div>
               <h6> B.  Quiz Data:</h6>
               <p>We may store:</p>
               <ul>
                <li>Quiz scores</li>
                <li>Selected quiz categories</li>
                <li>Game progress</li>
                <li>Coins, points, or rewards earned inside the website</li>
               </ul>
              </div>

              <div className='mt-4'>
                <h5>2. How We Use Your Information</h5>
                <p>We use collected information to:</p>
                <ul>
                  <li>Improve quiz experience</li>
                  <li>Save scores and progress</li>
                  <li>Analyze website traffic</li>
                  <li>Prevent misuse or cheating</li>
                  <li>Display advertisements</li>
                </ul>
              </div>

              <div className='mt-4'>
                <h5>3. Data Protection</h5>
                <p>We take reasonable security measures to protect your information. However, no online platform can guarantee complete security.</p>
              </div>

              <div className='mt-4'>
                <h5>4. Changes to This Privacy Policy</h5>
                <p>We may update this Privacy Policy anytime. Changes will be posted on this page with an updated date.</p>
              </div>

              <div className='mt-4 mb-5'>
                <h5>5. Contact Us</h5>
                <p>If you have any questions regarding this Privacy Policy, you can contact us at:</p>
                <ul>
                  <li>Email: <a href="mailto:admin@shareitforpcappdownload.com" style={{color:"rgb(108 177 255)"}}> admin@shareitforpcappdownload.com </a></li>
                </ul>
              </div>
              </div>
            </div>
      </div>
      </div>
      </div>
    </>
  )
}

export default Privacy
